import React from 'react';
import PropTypes from 'prop-types';
import LinkBankMicrosFormik from './LinkBankMicrosFormik';
import LinkBankMicrosForm from './LinkBankMicrosForm';
import { BanjoString } from '@stashinvest/react-banjo';
import { Text } from '@stashinvest/react-components';
import { Box } from '@stashinvest/ui';

export const initialBankMicrosFormValues = {
	accountType: '',
	routingNumber: '',
	accountNumber: '',
	confirmAccountNumber: '',
};

const LinkBankMicros = (props) => {
	const { onSubmit, submitting } = props;

	const handleOnSubmit = (values) => {
		onSubmit(values);
	};

	return (
		<Box className="px-contentSmall">
			<Text textStyle="headerSmall" className="mb-contentXS">
				<BanjoString stringId="information/instruct/externalBankDetails" />
			</Text>
			<LinkBankMicrosFormik
				onSubmit={handleOnSubmit}
				initialValues={initialBankMicrosFormValues}
				component={
					<LinkBankMicrosForm
						submitting={submitting}
						onValidationErrors={props.onValidationErrors}
						onBeforeValidation={props.onBeforeValidation}
					/>
				}
			/>
		</Box>
	);
};

LinkBankMicros.propTypes = {
	onSubmit: PropTypes.func,
	submitting: PropTypes.bool,
	onValidationErrors: PropTypes.func,
	onBeforeValidation: PropTypes.func,
};

export default LinkBankMicros;
